"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentErrorCode = exports.PaymentTypeId = exports.CardPaymentType = exports.Payment = void 0;
var Payment = /** @class */ (function () {
    function Payment() {
        this.id = 0;
        this.result = '';
        this.amount = 0;
        this.fee = 0;
        this.total = 0;
        this.status = '';
        this.type = '';
        this.createdCustomerName = '';
    }
    return Payment;
}());
exports.Payment = Payment;
var CardPaymentType;
(function (CardPaymentType) {
    CardPaymentType["VISA"] = "visa";
    CardPaymentType["MASTERCARD"] = "mastercard";
    CardPaymentType["DISCOVER"] = "discover";
    CardPaymentType["AMEX"] = "amex";
    CardPaymentType["JCB"] = "jcb";
    CardPaymentType["DINERSCLUB"] = "dinersclub";
    CardPaymentType["MAESTRO"] = "maestro";
    CardPaymentType["UNIONPAY"] = "unionpay";
})(CardPaymentType || (exports.CardPaymentType = CardPaymentType = {}));
var PaymentTypeId;
(function (PaymentTypeId) {
    PaymentTypeId[PaymentTypeId["E_CHECK_ID"] = 4] = "E_CHECK_ID";
    PaymentTypeId[PaymentTypeId["VISA_ID"] = 5] = "VISA_ID";
    PaymentTypeId[PaymentTypeId["MASTERCARD_ID"] = 6] = "MASTERCARD_ID";
    PaymentTypeId[PaymentTypeId["DISCOVER_ID"] = 7] = "DISCOVER_ID";
    PaymentTypeId[PaymentTypeId["AMERICAN_EXPRESS_ID"] = 8] = "AMERICAN_EXPRESS_ID";
    PaymentTypeId[PaymentTypeId["MONEY_GRAM_ID"] = 10] = "MONEY_GRAM_ID";
})(PaymentTypeId || (exports.PaymentTypeId = PaymentTypeId = {}));
/**
 * Payment API Error Codes
 * These codes are returned from the Payments API make_payment endpoint
 * to indicate specific failure conditions.
 *
 * HTTP Status Code Mapping:
 * - Codes 100-300: Return 400 Bad Request
 * - Codes 400+: Return 500 Internal Server Error
 */
var PaymentErrorCode;
(function (PaymentErrorCode) {
    PaymentErrorCode[PaymentErrorCode["AccessTokenInvalid"] = 100] = "AccessTokenInvalid";
    PaymentErrorCode[PaymentErrorCode["AccessTokenExpired"] = 101] = "AccessTokenExpired";
    PaymentErrorCode[PaymentErrorCode["AccessTokenFailure"] = 102] = "AccessTokenFailure";
    PaymentErrorCode[PaymentErrorCode["RequestDataInvalid"] = 200] = "RequestDataInvalid";
    PaymentErrorCode[PaymentErrorCode["RequestDataFailure"] = 201] = "RequestDataFailure";
    PaymentErrorCode[PaymentErrorCode["RequestCidInvalid"] = 300] = "RequestCidInvalid";
    PaymentErrorCode[PaymentErrorCode["ServiceDatabaseUnavailable"] = 400] = "ServiceDatabaseUnavailable";
    PaymentErrorCode[PaymentErrorCode["ServiceDatabaseMaintenance"] = 401] = "ServiceDatabaseMaintenance";
    PaymentErrorCode[PaymentErrorCode["FailedToLoadMerchantData"] = 600] = "FailedToLoadMerchantData";
    PaymentErrorCode[PaymentErrorCode["FailedToLoadPaymentData"] = 700] = "FailedToLoadPaymentData";
    PaymentErrorCode[PaymentErrorCode["FailedToValidatePaymentData"] = 701] = "FailedToValidatePaymentData";
    PaymentErrorCode[PaymentErrorCode["FailedToProcessPayment"] = 702] = "FailedToProcessPayment";
    PaymentErrorCode[PaymentErrorCode["DuplicatePayment"] = 703] = "DuplicatePayment";
    PaymentErrorCode[PaymentErrorCode["FailedToSendEmail"] = 901] = "FailedToSendEmail";
})(PaymentErrorCode || (exports.PaymentErrorCode = PaymentErrorCode = {}));
